import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  SlDrawer,
  SlInput,
  SlIcon,
  SlOption,
  SlSelect,
} from "@shoelace-style/shoelace/dist/react";
import AsyncSelect from "react-select/async";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import { formatDate, formatDateYYYYMMDD } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import {
  roles,
  langoptions,
  NewspaperDistrictEditonAdformats,
  NewspaperMainEditonAdformats,
  capitalizeFirstLetter,
  clusters
} from "../../utils/constants";
import { useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import Button from "react-bootstrap/Button";
import Datepicker from "react-tailwindcss-datepicker";
import NoImage from "../../assets/images/NoImage.png";
import EditIcon from "../../assets/images/edit_icon.svg";
import UserIcon from "../../assets/images/user_icon.svg";
import filterSvg from "../../assets/images/filter.svg";
import LocationSVG from "../../assets/images/location.svg";
import Select from "react-select";
import { Modal,ModalHeader, ModalBody } from "react-bootstrap";
import { SetBirdViewFilters } from "../../redux/counterSlice";
import { debounce, debouncePromise } from "../../utils/Debounce";
import ScrollContainer from "react-indiana-drag-scroll";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
function CompetitorDataAI() {
  const dispatch = useDispatch();
  const [flag, setFlag] = useState("");
  const [show, setShow] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [advDetails, setAdvDetails] = useState();
  const [preview, setPreview] = useState(false);
  const today = new Date().toISOString().split("T")[0];

  const [dateRange, setDateRange] = useState({
    startDate: today,
    endDate: today,
  });

  const [open, setOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [adType, setAdType] = useState("Finite");
  const [selectedBrandType, setSelectedBrandType] = useState("0");
  const [newspapers, setNewspapers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [newspaperLocations, setNewspaperLocations] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  // const [merge, setMerge] = useState(false);
  const [brands, setBrands] = useState([]);
  const [imgUrl, setImgUrl] = useState("");
  const [editions, setEditions] = useState([]);
  const observer = useRef();
  const [infLoader, setInfLoader] = useState(false);
  const [newspaperData, setNewsPaperData] = useState([]);
  const [imgSrc, setImgSrc] = useState(NoImage);
  const [originalUrl, setOriginalUrl] = useState("");
  const [showOriginal, setShowOriginal] = useState(false);
  const [category, setCategory] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [stats, setStats] = useState([]);
  const [showConsultees, setShowConsultees] = useState(false);
  const [consultees, setConsultees] = useState([]);
  const [consulteeFlag, setConsulteeFlag] = useState(false);
  const drawerRef = useRef(null);
  const [consulteeId, setConsulteeId] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showInfo, setShowInfo] = useState(false)
  const [info,setInfo] = useState({})

  const [clusterOptions, setClusterOptions] = useState([]);
  const [clusterLoading, setClusterLoading] = useState(false);

  const handleSelect = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };
  const [alphaCategories, setAlphaCategories] = useState([])
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
    isSubmitting,
    reset,
  } = useForm();
  const form1 = useForm()
  const watchEdition = watch("edition");
  const watchLanguage = watch("language");
  const watchAdFormat = watch("ad_format");
  const watchNewspaperName = watch("newspaper_name");
  const watchBrandType = watch("brand_type");
  const watchLocation = watch("location");
  const watchCluster = watch("cluster");

  const pageNameLower = watchEdition?.value
    ? watchEdition?.value.toLowerCase()
    : "";
  const isMain = pageNameLower.includes("main");
  const isDistrict = pageNameLower.includes("district");
  const AdFormatOptions = isMain
    ? NewspaperMainEditonAdformats
    : isDistrict
    ? NewspaperDistrictEditonAdformats
    : NewspaperMainEditonAdformats;

  const searchFilterOnChange = (e) => {
    setSearch(e.target.value);
    setData([]);
    setCurrentPage(0);
  };
  const getBrandsAlias = async (checker) => {
    try {
      if (!checker) return [];
      let requestObj = { search: checker, brand_type: watchBrandType };
      const brandsResult = await api({
        url: "user/sales_persons/getBrands",
        method: "POST",
        responseType: "json",
        data: requestObj,
      });
      if (brandsResult?.code === 200) {
        // setBrandsList(brandsResult.data)
        return brandsResult.data;
      } else return [];
    } catch (error) {
      console.error("Error @ getBrands", error);
    }
  };
  const debouncedGetBrands = debouncePromise(getBrandsAlias, 500);

  const handleDateRange = (selectedDate) => {
    setData([]);
    setCurrentPage(0);
    if (selectedDate) {
      if (selectedDate.startDate && selectedDate.endDate) {
        setDateRange(selectedDate);
      } else {
        setDateRange({ startDate: null, endDate: null });
      }
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const fetchNewsPapers = async () => {
    try {
      let res = await api({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleClose = () => {
    reset();
    setShow(false);
    setSubmit(false);
    setShowOriginal(false);
    setValue("edition", null);
    reset({ edition: null, locaion: null });
    setRejectReason("");
  };
  const loadData = async (
    search = "",
    page = 0,
    selectedLocation,
    dateRange,
    adType,
    selectedNewspaper,
    userType,
    from
  ) => {
    try {
      console.log("HERE")
      if (
        localStorage.getItem("role") === roles.b2b ||
        localStorage.getItem("role") === roles.salesperson
      ) {
        console.log("HERE TOO")
        if (data?.length === 0) {
          setLoader(true);
        } else setInfLoader(true);
        const response = await api({
          url: `/birdview/getai`,
          method: "POST",
          responseType: "json",
          data: {
            BirdViewSearch: search,
            page,
            BirdViewSource: selectedLocation.length
              ? selectedLocation.map((item) => item.value)
              : [],
            dateRange,
            adType,
            selectedNewspaper: selectedNewspaper.length
              ? selectedNewspaper.map((item) => item.value)
              : [],
            selectedBrandType: +selectedBrandType,
            limit: 20,
            userType,
          },
        });
        if (response?.code === 200) {
          if (from === "reject" || from === "submit") {
            setData(response?.data?.res);
          } else {
            setData([...data, ...response?.data?.res]);
          }
          setTotalRecords(response?.data?.totalCount);
          setStats(response?.data?.stats);
          setLoader(false);
          setInfLoader(false);
          setRejectReason("");
        } else {
          Toast('error', response?.data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  const loadLocations = async () => {
    // if ((localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) && adType === "District") {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        // url: `/birdview/birdviewLocations`,
        url: `/birdview/brandsLocations`,
        method: "POST",
        responseType: "json",
      });
      if (response?.code === 200) {
        setLocations([...response?.data?.result]);
      } 
    }
  };
  const getEstimatedValue = async (
    language,
    edition,
    ad_format,
    newspaper_name,
    location,
    cluster
  ) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const locationValues = Array.isArray(location) ? location.map(l => l?.label) : [];
      const clusterValues = Array.isArray(cluster) ? cluster.map(c => c?.label) : [];
      const response = await api({
        url: `/birdview/estimatedvalue`,
        method: "POST",
        responseType: "json",
        data: {
          lang_id: language,
          edition: edition,
          ad_format: ad_format,
          newspaper_name: newspaper_name,
          location: locationValues.length ? locationValues : undefined,
          clusters: clusterValues.length ? clusterValues : undefined
        },
      });
      if (response?.code === 200) {
        setValue("estimated_value", response?.data?.result?.estimated_value);
      } 
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadNewspapers();
      loadEditions();
      loadBrands();
      loadNewspaperLocations();
    }
    fetchNewsPapers();
    return () => {
      dispatch(
        SetBirdViewFilters({
          search: "",
          selectedLocation: [],
          dateRange: {
            startDate: today,
            endDate: today,
          },
          adType: "finite",
          selectedNewspaper: [],
        })
      );
    };
  }, []);
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadLocations();
    }
  }, [adType]);

  const loadNewspapers = useCallback(async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_names`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setNewspapers(response?.data?.result);
      }
    }
  }, []);

  const loadBrands = useCallback(async () => {
    try {
      if (
        localStorage.getItem("role") === roles.b2b ||
        localStorage.getItem("role") === roles.salesperson
      ) {
        const response = await api({
          url: `/birdview/birdview_brands`,
          method: "POST",
          responseType: "json",
        });
        if (response?.code === 200) {
          setBrands(response?.data?.result);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  const loadNewspaperLocations = useCallback(async (language, edition) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_locations`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language, edition: edition },
      });
      if (response?.code === 200) {
        setNewspaperLocations(response?.data?.result);
      } 
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      getEstimatedValue(
        watchLanguage?.value,
        watchEdition?.value,
        watchAdFormat?.label,
        watchNewspaperName?.value,
        watchLocation,
        watchCluster
      );
    }
  }, [
    watchLanguage?.value,
    watchEdition?.value,
    watchAdFormat?.label,
    watchNewspaperName?.value,
    watchLocation,
    watchCluster
  ]);
  useEffect(() => {
    if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
        loadNewspaperLocations(watchLanguage?.value, watchEdition?.value);

    }
}, [watchLanguage, watchEdition])
  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };
  const getColors = (brand) => {
    brand = capitalizeFirstLetter(brand);
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
      backgroundColor: brandLookup[0]?.background_color,
      color: brandLookup[0]?.color,
    };
  };
  const handleShow = async (choose, item) => {
    setInfo(item)
    if (choose === "edit") {
      setValue("date", formatDateYYYYMMDD(item?.date));
      setValue(
        "language",
        langoptions.find((option) => option.value === item?.language) || langoptions.find((option) => option.label.toLowerCase() === "telugu")
      );
      setValue(
        "newspaper_name",
        newspapers.find(
          (option) =>
            option.value === capitalizeFirstLetter(item?.newspaper_name)
        ) || newspapers.find((option) => option.label.toLowerCase() === "eenadu")
      );
      setValue("page_no", item.page_no);
      let edition = mergeEditions(item?.edition);
      setValue(
        "edition",
        editions.find(
          (option) =>
            option?.value.toLowerCase() === edition?.toLowerCase()
        )
      );
      setValue(
        "location",
        newspaperLocations?.find((option) => +option.value === +item?.location)
      );
      setValue(
        "ad_format",
        AdFormatOptions.find((option) => option.label === item?.ad_format)
      );
      setValue("estimated_value", item.estimated_value);
      setValue("campaign_name", item.campaign_name);
      setValue(
        "brand_name",
        brands.find(
          (option) =>
            option.label?.split(" (")[0]?.toLowerCase() ===
            item?.brand_name?.toLowerCase()
        )?.value
      );
      setValue(
        "brand_type",
        item?.brand_type === "finite"
          ? "finite"
          : item?.brand_type === "infinite"
          ? "infinite"
          : "others"
      );
      setImgUrl(item?.image_url);
      setOriginalUrl(item?.original_url);
      setCategory(item?.category);
      setUpdateId(item?.id);
      setValue('phone_numbers',item?.contact_details)
      setValue('location_details', item.location_details)
      setValue('person_names', item.person_names)
      setShow(true);
      await getEstimatedValue(
        item?.language,
        edition,
        item.ad_format,
        item.newspaper_name,
        item.location,
        item.cluster
      );
    }
    if (choose === "add") {
      setValue("language", langoptions.find((option) => option.label.toLowerCase() === "telugu"));
      setValue("newspaper_name", newspapers.find((option) => option.label.toLowerCase() === "eenadu"));
      setShow(true);
    }
  };
  const lastItemRef = useCallback(
    (node) => {
      if (loader) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (data?.length < totalRecords) {
            setCurrentPage((prevPage) => prevPage + 1);
          }
        }
      });
      if (node) observer.current.observe(node);
    },
    [loader]
  );
  const loadEditions = useCallback(async (language) => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      const response = await api({
        url: `/birdview/newspaper_editions`,
        method: "POST",
        responseType: "json",
        data: { lang_id: language },
      });
      if (response?.code === 200) {
        setEditions(response?.data?.result);
      } 
    }
  }, []);
  const onSubmit = async (data) => {
    const locations = data.location?.map(location => location.label)
    const clusters = data.cluster?.map(cluster => cluster.label)
    try {
      let res = await api({
        url: `/birdview/addai`,
        method: "POST",
        responseType: "json",
        data: {
          ad_format: data?.ad_format?.label,
          brand_name: data?.brand_name,
          brand_type: data?.brand_type,
          campaign_name: data?.campaign_name,
          date: data?.date,
          edition: data?.edition?.value,
          estimated_value: data.estimated_value,
          language: data?.language?.value,
          newspaper_name: data?.newspaper_name?.value,
          page_no: data?.page_no,
          location: locations,
          upload_url: imgUrl,
          original_url: originalUrl,
          category: category,
          id: updateId,
          advertisers:JSON.stringify(consultees),
          clusters:clusters
        },
      });
      if (res?.code === 200) {
        handleClose();
        reset();
        setFlag("");
        setCurrentPage(0);
        loadData(
          search,
          0,
          selectedLocation,
          dateRange,
          adType,
          selectedNewspaper,
          selectedBrandType,
          "submit"
        );
        dispatch(
          SetBirdViewFilters({
            search,
            selectedLocation,
            dateRange,
            adType,
            selectedNewspaper,
            selectedBrandType,
          })
        );
        setImgUrl("");
        setOriginalUrl("");
        setShowOriginal(false);
        Toast("success", "Birdview Added Successfully");
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Something went Wrong");
    }
  };
  const onReject = async () => {
    try {
      let res = await api({
        url: `/birdview/reject`,
        method: "POST",
        responseType: "json",
        data: {
          id: updateId,
          reason: rejectReason,
        },
      });
      if (res?.code === 200) {
        setData([])
        handleClose();
        reset();
        setFlag("");
        setCurrentPage(0);
        loadData(
          search,
          0,
          selectedLocation,
          dateRange,
          adType,
          selectedNewspaper,
          selectedBrandType,
          "reject"
        );
        dispatch(
          SetBirdViewFilters({
            search,
            selectedLocation,
            dateRange,
            adType,
            selectedNewspaper,
            selectedBrandType,
          })
        );
        setImgUrl("");
        setOriginalUrl("");
        setShowOriginal(false);
        Toast("success", "Birdview Rejected Successfully");
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Something went Wrong");
    }
  };

  const loadCategories = async () => {
    try {
      let res = await api({
        url: "/birdview/alphacategory",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setAlphaCategories(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const addConsultees = (data) => {
    console.log(data)
    if(consulteeFlag === 'edit'){
      let index = consultees.findIndex((item) => item.id === consulteeId);
      let temp = [...consultees]
      temp[index] = data
      setConsultees(temp)
      setShowConsultees(false)
      return
    }
    let index = consultees.findIndex((item) => item.person_name === data.person_name && item.phone_number === data.phone_number );
    if(index !== -1){
      Toast('warning', "Dupliacte Records")
      return
    }
    data.id = `${Date.now()}-${Math.floor(Math.random() * 1000)}`
    setConsultees([...consultees, data]);
    form1.reset()
    setShowConsultees(false)
  };
  function mergeEditions(editions) {
    if (!Array.isArray(editions) || editions.length === 0) return "";
    if(editions.length === 1){
      return editions[0]
    }
    // Remove duplicates and sort
    const uniqueEditions = [...new Set(editions)].sort();

    // Extract "main edition" from the last item
    let mainEdition = "main edition";
    let processed = uniqueEditions.map(e => e.replace(mainEdition, "").trim());
    // Join all except the last one with " + "
    let result = processed?.join(" + ");

    // Add the last one with " main edition"
    return result ? result + " " + mainEdition : "";
    // Add the last one with " main edition"
}
const handleEdit = (data)=>{
  setShowConsultees(true)
  form1.setValue('person_name', data.person_name)
  form1.setValue('contact',data.contact)
  form1.setValue('address', data.address)
}
  const handleDelete = (data) => {
    const filterData = consultees.filter((item) => item.id !== data.id);
    setConsultees(filterData)
  }
  const getStats = (status) => {
    let filtered = stats.filter((item) => item.status === status);
    return isNaN(filtered.length) ? 0 : +filtered.length;
  };
  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.b2b ||
      localStorage.getItem("role") === roles.salesperson
    ) {
      loadData(
        search,
        0,
        selectedLocation,
        dateRange,
        adType,
        selectedNewspaper,
        selectedBrandType
      );
      dispatch(
        SetBirdViewFilters({
          search,
          selectedLocation,
          dateRange,
          adType,
          selectedNewspaper,
          selectedBrandType,
        })
      );
    }
  }, [
    search,
    selectedLocation,
    dateRange,
    adType,
    selectedBrandType,
    selectedNewspaper,
  ]);

  useEffect(() => {
    console.log(currentPage);
    if (currentPage !== 0) {
      loadData(
        search,
        currentPage,
        selectedLocation,
        dateRange,
        adType,
        selectedNewspaper
      );
    }
  }, [currentPage]);

  useEffect(() => {
    if (showConsultees) {
      drawerRef.current?.setAttribute("inert",'true'); // Restore default behavior
    } else {
      drawerRef.current?.removeAttribute("inert"); // Ensure it doesn't trap focus
    }
  }, [showConsultees]);

  useEffect(()=>{
    loadCategories()
  },[])

  const getClusters = (lables=[]) => {
    const locations = lables.length > 0 ?  lables : watch('location');
    if(!locations) return []
    const locationsLabels = locations?.map(location => location.label);
    let clusterset = new Set();
  
    for (let location of locationsLabels) {
      let clusterValues = clusters[location];
      clusterValues?.forEach(val => clusterset.add(val));
    }
  
    const clusterArray = Array.from(clusterset);
  
    return clusterArray.map(loc => ({ label: loc, value: loc }));
  };

  useEffect(() => {
    const locations = watchLocation;
    if (
      Array.isArray(locations) &&
      locations.length === 1 &&
      watchEdition?.value?.toLowerCase().includes("district")
    ) {
      setClusterLoading(true);
      api({
        url: "/birdview/getClusters",
        method: "POST",
        responseType: "json",
        data: { district: locations[0].label },
      }).then((res) => {
        if (res?.code === 200 && Array.isArray(res.data)) {
          setClusterOptions(res.data.map((c) => ({ label: c, value: c })));
        } else {
          setClusterOptions([]);
        }
      }).finally(() => setClusterLoading(false));
    } else {
      setClusterOptions([]);
    }
  }, [watchLocation, watchEdition]);

  useEffect(() => {
    setValue("location", []);
    setValue("cluster", []);
  }, [watchLanguage, watchEdition]);

  return (
    <>
      <ScrollContainer>
        <table className="table table-bordered my-2">
          <thead>
            <tr>
              <th>Totals</th>
              <th>Under Review</th>
              <th>Approved</th>
              <th>Rejected</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{getStats(0) + getStats(1) + getStats(2)}</td>
              <td>{getStats(1)}</td>
              <td>{getStats(0)}</td>
              <td>{getStats(2)}</td>
            </tr>
          </tbody>
        </table>
      </ScrollContainer>
      <div className={`flex gap-2 justify-end my-2 items-center stickyFilters`}>
        <div className="flex gap-4 justify-end mobHide">
          <div>
            <Select
              className=""
              placeholder="Select Newspaper"
              name="source"
              size="medium"
              value={selectedNewspaper}
              onChange={(selected) => {
                setSelectedNewspaper(selected || []);
                setData([]);
                setCurrentPage(0);
              }}
              options={[
                ...newspaperData
                  .filter((item) => item.name !== "Way2news")
                  .map((item) => {
                    return { label: item.name, value: item.name };
                  }),
              ]}
              isMulti
            />
          </div>
          <div>
            <Select
              className=""
              placeholder="Select District"
              name="source"
              size="medium"
              value={selectedLocation}
              onChange={(selected) => {
                setSelectedLocation(selected || []);
                setData([]);
                setCurrentPage(0);
              }}
              options={[...locations]}
              isMulti
            />
          </div>
          <div>
            <SlSelect
              className="w-40"
              placeholder="Select Ad Type"
              name="adType"
              size="medium"
              value={adType}
              onSlChange={(e) => {
                setAdType(e.target.value);
                setData([]);
                setCurrentPage(0);
              }}
            >
              <SlOption key={0} value={"Finite"}>
                Finite
              </SlOption>
              <SlOption key={1} value={"Infinite"}>
                Infinite
              </SlOption>
            </SlSelect>
          </div>
          <div>
            <SlSelect
              className="w-40"
              placeholder="Select Brand Type"
              name="adType"
              size="medium"
              value={selectedBrandType}
              onSlChange={(e) => {
                setSelectedBrandType(e.target.value);
                setData([]);
                setCurrentPage(0);
              }}
            >
              <SlOption key={0} value={"0"}>
                All
              </SlOption>
              <SlOption key={1} value={"1"}>
                National
              </SlOption>
              <SlOption key={2} value={"2"}>
                Local
              </SlOption>
              <SlOption key={3} value={"3"}>
                Metro
              </SlOption>
              <SlOption key={4} value={"4"}>
                Local-TN
              </SlOption>
            </SlSelect>
          </div>

          <SlInput
            className="w-full"
            size="medium"
            placeholder="Newspaper/Edition/Adv Name "
            onSlInput={debounce(searchFilterOnChange, 500)}
            style={{ width: "230px" }}
          >
            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
          </SlInput>
          <div className="border rounded-lg min-w-fit h-fit">
            <Datepicker
              classNames="form-input "
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              useRange={true} // Allow date range selection
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleDateRange}
            />
          </div>
        </div>
        <img
          src={filterSvg}
          alt="filter"
          onClick={() => setShowFilter(true)}
          className="w-6 mobileOnly"
        ></img>
      </div>
      <SlDrawer
        label={"Add BirdView"}
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={handleClose}
        style={{ "--size": "90vw" }}
        ref={drawerRef}
      >
        <div className="grid grid-cols-3  gap-3">
          <form
            className="col-span-2"
            onSubmit={handleSubmit(onSubmit)}
            encType="multipart/form-data"
          >
            <div className="flex gap-3">
              <div className="w-1/2">
                <div className="mb-3">
                  <label>Date</label>
                  <span className="text-red-600">*</span>
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Choose Date"
                    {...register("date", { required: "Date is required" })}
                  />
                  {submit && errors.date && (
                    <div className="text-red-600">{errors.date.message}</div>
                  )}
                </div>

                {/* Language */}
                <div className="mb-3">
                  <label className="form-label">Language</label>
                  <Controller
                    name="language" // Set the name to "language"
                    control={control}
                    rules={{ required: "Language is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="language" // Ensure the name is consistent
                        placeholder="Select Language"
                        options={langoptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    )}
                  />
                  {submit && errors.language && (
                    <div className="text-red-600">
                      {errors.language.message}
                    </div>
                  )}
                </div>

                {/* Newspaper Name */}
                <div className="mb-3">
                  <label className="mb-1">Newspaper Name</label>
                  <span className="text-red-600">*</span>
                  <Controller
                    control={control}
                    name="newspaper_name"
                    // rules={{ required: true }}
                    rules={{ required: "Newspaper Name is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="newspaper_name" // Ensure the name is consistent
                        placeholder="Select Newspaper Anme"
                        options={newspapers}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    )}
                  />
                  {submit && errors.newspaper_name && (
                    <div className="text-red-600">
                      {errors.newspaper_name.message}
                    </div>
                  )}
                </div>

                {/* Page Number */}
                <div className="mb-3">
                  <label className="mb-1">Page Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Page Number"
                    {...register("page_no")}
                  />
                  {submit && errors.page_no && (
                    <div className="text-red-600">{errors.page_no.message}</div>
                  )}
                </div>
              </div>
              {/* Date Field */}

              <div className="w-1/2">
                {/* Edition */}
                <div className="mb-3">
                  <label className="form-label">Edition</label>
                  <Controller
                    name="edition" // Set the name to "edition"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="edition" // Ensure the name is consistent
                        placeholder="Select Edition"
                        options={editions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    )}
                  />
                  {submit && errors.edition && (
                    <div className="text-red-600">{errors.edition.message}</div>
                  )}
                </div>
                {/* Location */}
                {watch("edition")?.value?.toLowerCase().includes("district") && (
                  <>
                    <div>
                      <label className="mb-1 mr-2">District</label>
                      <Controller
                        control={control}
                        name="location"
                        render={({ field }) => (
                          <Select
                            {...field}
                            name="location"
                            placeholder="Select District"
                            options={newspaperLocations}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isMulti
                          />
                        )}
                      />
                      {errors.location && (
                        <div className="text-red-600">{errors.location.message}</div>
                      )}
                    </div>
                    {Array.isArray(watchLocation) && watchLocation.length === 1 && (
                      <div>
                        <label className="mb-1 mr-2">Cluster</label>
                        <Controller
                          control={control}
                          name="cluster"
                          render={({ field }) => (
                            <Select
                              {...field}
                              name="cluster"
                              placeholder={clusterLoading ? "Loading..." : "Select cluster"}
                              options={clusterOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isMulti
                              isDisabled={clusterLoading}
                            />
                          )}
                        />
                        {errors.cluster && (
                          <div className="text-red-600">{errors.cluster.message}</div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* Ad Format */}
                <div className="mb-3">
                  <label className="mb-1">Ad Format</label>
                  <span className="text-red-600">*</span>
                  <Controller
                    control={control}
                    name="ad_format"
                    rules={{ required: "Ad Format is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        name="ad_format" // Ensure the name is consistent
                        placeholder="Select Ad Format"
                        options={AdFormatOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                    )}
                  />
                  {errors.ad_format && (
                    <div className="text-red-600">
                      {errors.ad_format.message}
                    </div>
                  )}
                </div>

                {/* Estimated Price */}
                <div className="mb-3">
                  <label className="mb-1">Estimated Price</label>
                  <span className="text-red-600">*</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Estimated Price"
                    aria-label="Estimated Price"
                    {...register("estimated_value", {
                      required: "Estimated Price is required",
                    })}
                  />
                  {errors.estimated_value && (
                    <div className="text-red-600">
                      {errors.estimated_value.message}
                    </div>
                  )}
                </div>

                {/* Campaign Name Field */}
                <div className="mb-3">
                  <label className="mb-1">Campaign Name</label>
                  <span className="text-red-600">*</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Campaign Name"
                    aria-label="Campaign Name"
                    {...register("campaign_name", {
                      required: "Campaign Name is required",
                    })}
                  />
                  {errors.campaign_name && (
                    <div className="text-red-600">
                      {errors.campaign_name.message}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Brand Type Finite or infinite */}
            <label className="mb-1 form-label">Brand Type</label>
            <div className="mb-3 competitorAiRadios">
              <div className="d-flex gap-1">
                <input
                  type="radio"
                  id="finite"
                  {...register("brand_type")}
                  value="finite"
                  defaultChecked
                  onChange={() => {
                    setValue("brand_type", "finite");
                  }}
                />
                <label htmlFor="finite">Finite</label>
                <input
                  type="radio"
                  id="infinite"
                  {...register("brand_type")}
                  value="infinite"
                  onChange={() => {
                    setValue("brand_type", "infinite");
                  }}
                />
                <label htmlFor="infinite">Infinite</label>
                <input
                  type="radio"
                  id="alpha"
                  {...register("brand_type")}
                  value="alpha"
                  onChange={() => {
                    setValue("brand_type", "alpha");
                    setValue("brand_name", "");
                  }}
                />
                <label htmlFor="alpha">Alpha</label>
              </div>
            </div>

            {/* Brand Name */}
            {watchBrandType !== "alpha" && (
              <div className="mb-3">
                <label className="mb-1">Brand Name</label>
                <span className="text-red-600">*</span>
                <Controller
                  control={control}
                  name="brand_name"
                  rules={{ required: "Brand Name is required" }}
                  render={({ field }) => (
                    <AsyncSelect
                      {...field}
                      name="brand_name" // Ensure the name is consistent
                      placeholder="Select Brand Name"
                      defaultOptions={brands}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      loadOptions={debouncedGetBrands}
                      value={defaultValue(brands, getValues("brand_name"))}
                      onChange={(selected) =>
                        setValue("brand_name", selected?.value)
                      }
                    />
                  )}
                />
                {errors.brand_name && (
                  <div className="text-red-600">
                    {errors.brand_name.message}
                  </div>
                )}
              </div>
            )}
            {watchBrandType === "alpha" && <legend>Alpha Ads</legend>}
            {/* {watchBrandType === "alpha" && <>
            <div className="my-2">
                <label className="mb-1">Phone Numbers</label>  
                <Controller
                control={control}
                name="phone_numbers"
                render={({ field }) => (
                  <input type="text" className="form-control" placeholder="Enter Mobile Numbers" {...field} />
                )}></Controller>
                 
              </div>
              <div className="my-2">
                <label className="mb-1">Location Details</label>  
                <Controller
                control={control}
                name="location_details"
                render={({ field }) => (
                  <input type="text" className="form-control" placeholder="Enter Location details" {...field} />
                )}></Controller>
              
              </div>
              <div className="my-2">
                <label className="mb-1">Person Names</label>  
                <Controller
                control={control}
                name="person_names"
                render={({ field }) => (
                  <input type="text" className="form-control" placeholder="Enter Person Names" {...field} />
                )}></Controller>
              
              </div>
              </>} */}
            {watchBrandType === "alpha" && (
              <section className="flex gap-3 w-full">
                <div className="w-1/2">
                  <div className="mb-3">
                    <label className="form-label">Category</label>
                    <Controller
                      name="alpha_category" // Set the name to "language"
                      control={control}
                      rules={{ required: "Category is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          name="alpha_category" // Ensure the name is consistent
                          placeholder="Select Category"
                          options={alphaCategories}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                      )}
                    />
                    {submit && errors.alpha_category && (
                      <div className="text-red-600">
                        {errors.alpha_category.message}
                      </div>
                    )}
                  </div>
                  {/* <div className="mb-3">
                    <label className="mb-1">Person Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Person Name"
                      {...register("person_name", {
                        required: watchBrandType === "alpha",
                      })}
                    />
                    {submit && errors.person_name && (
                      <div className="text-red-600">
                        {'Person Name is required'}
                      </div>
                    )}
                  </div> */}
                </div>
                {/* <div className="w-1/2">
                  <div className="mb-3">
                    <label className="mb-1">Event Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Event Name"
                      {...register("event_name", {
                        required: watchBrandType === "alpha",
                      })}
                    />
                    {submit && errors.event_name && (
                      <div className="text-red-600">
                        {'Event Name is required!'}
                      </div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="mb-1">Event Date</label>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Choose Date"
                      {...register("event_date", {
                        required: watchBrandType === "alpha",
                      })}
                    />
                    {submit && errors.event_date && (
                      <div className="text-red-600">
                        {'Event Date is requried!'}
                      </div>
                    )}
                  </div>
                </div> */}
              </section>
            )}
            {watchBrandType === "alpha" && (
              <>
                {" "}
                <legend>Add Consultees</legend>
                <section>
                  <button className="ml-auto justify-end mt-0 !no-underline  btn btn-link !text-green-800 items-center !flex" onClick={()=>{setShowConsultees(true); setConsulteeFlag('add')}}>Add &nbsp; <SlIcon name="plus-circle" library="lucide"></SlIcon></button>
                  {consultees.length > 0 && <table className="table table-bordered">
                    <thead className="bg-gray-100">
                      <tr>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Address</th>
                        <th>Edit</th>
                      </tr>
                      </thead>
                      <tbody>
                        {consultees.map((consultee,index)=> (
                          <tr key={consultee.name}>
                            <td>{consultee[`person_name`]}</td>
                            <td>{consultee[`contact`]}</td>
                            <td>{consultee[`address`]}</td>
                            <td className="flex gap-3">
                              <SlIcon title="Edit" library="lucide" name="pencil" className="w-6 h-6 cursor-pointer text-green-500 hover:text-green-600" onClick={() => {handleEdit(consultee);setConsulteeFlag('edit')}}></SlIcon>
                              <SlIcon title="Delete" library="lucide" name="trash-2" className="w-6 h-6 cursor-pointer text-red-500 hover:text-red-600" onClick={()=>{handleDelete(consultee)}}></SlIcon>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>}
                </section>
              </>
            )}
            {/* Submit Button */}
            <div className="mb-3 flex gap-3 w-full items-center">
              <button
                type="submit"
                className="btn btn-primary w-1/3"
                onClick={() => setSubmit(true)}
                disabled={isSubmitting || rejectReason.trim().length !== 0}
              >
                Submit
              </button>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Reject Reason"
                  aria-label="Reject Reason"
                  aria-describedby="button-addon2"
                  onChange={(e) => setRejectReason(e.target.value)}
                />
                <button
                  class="btn btn-danger"
                  type="button"
                  id="button-addon2"
                  onClick={onReject}
                  disabled={rejectReason.trim().length === 0}
                >
                  Reject
                </button>
              </div>
            </div>
          </form>
          <div className="col-span-1">
      <div className="d-flex justify-content-between align-items-center w-100 mb-2">
        <div className="flex gap-3 items-center justify-center">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="switchUrls"
            onChange={() => setShowOriginal((prev) => !prev)}
            checked={showOriginal}
          />
          <label className="form-check-label" htmlFor="switchUrls">
            Show Paper
          </label>
        </div>
        <span className="flex gap-1 items-center justify-center cursor-pointer" onClick={()=>setShowInfo(true)}><SlIcon library="lucide" name="info" className="w-6 h-6 cursor-pointer" title="info" >
        </SlIcon>Info</span>
        <Modal show={showInfo} onHide={()=>setShowInfo(false)}>
          <ModalHeader closeButton>
          Campaign Info
          </ModalHeader>
          <ModalBody>
            <h6>Locations: {info?.location?.join(", ")}</h6>
            <h6>Editions: {info?.edition?.join(", ")}</h6>
            </ModalBody>
        </Modal>
        </div>
        <a
          className="text-decoration-none text-black hover:text-primary"
          title="Open in new tab"
          href={showOriginal ? originalUrl[currentIndex] : imgUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <SlIcon name="launch" library="material" className="w-6 h-6" title="Show in New page"/>
        </a>
      </div>

      {showOriginal && originalUrl.length > 1 ? (
        <Carousel activeIndex={currentIndex} onSelect={handleSelect} className="rounded-md max-h-[84vh]">
          <style>
            {`
              .carousel-control-prev-icon,
              .carousel-control-next-icon {
              filter: brightness(0) saturate(100%) invert(18%) sepia(94%) saturate(3172%) hue-rotate(216deg) brightness(100%) contrast(105%);
            }
            `}
          </style>
          {originalUrl.map((url, index) => (
            <Carousel.Item key={index}>
              <img src={url} alt={`ad-preview-${index}`} className="d-block w-100 rounded-md" loading="lazy" />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <img
          src={showOriginal && originalUrl.length > 0 ? originalUrl[0] : imgUrl}
          alt="ad-preview"
          className="d-block w-100 rounded-md max-h-[84vh]"
          loading="lazy"
        />
      )}
    </div>

        </div>
      </SlDrawer>

      {
        // New infinite scrolling
        data?.length && !loader ? (
          <div class="birdviewWrapper">
            <ul class="birdview">
              {data.map((item, index) => {
                if (data.length !== index + 1) {
                  return (
                    <li key={item.id}>
                      <div class="theme">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="placeholder" />
                        ) : (
                          <img src={NoImage} alt="placeholder" />
                        )}
                        <div class="blur">
                          {" "}
                          {item?.image_url ? (
                            <img src={item.image_url} alt="placeholder" />
                          ) : (
                            <img src={NoImage} alt="placeholder" />
                          )}
                        </div>
                        <div class="publisher">
                          {item?.newspaper_name ? (
                            <h6 style={getColors(item?.newspaper_name)}>
                              {item.newspaper_name}
                            </h6>
                          ) : null}
                          {item?.ad_type === "Local" ? (
                            <h6 class="local">{item.brand_type}</h6>
                          ) : item?.brand_type === "National" ? (
                            <h6 class="national">{item.brand_type}</h6>
                          ) : (
                            <h6 class="districts">{item.brand_type}</h6>
                          )}
                        </div>
                        <p className="location">
                          <img
                            src={LocationSVG}
                            alt="location_name"
                            title={item.location}
                          />
                          {item.location}
                        </p>
                        <p class="estimation">
                          Est Val: <strong>{item.estimated_value || 0}</strong>
                        </p>
                        {item.image_url ? (
                          <Button
                            className="previewBtn"
                            variant="neutral"
                            onClick={() => {
                              setImgSrc(item.image_url);
                              setOpen(true);
                            }}
                          >
                            Preview
                          </Button>
                        ) : null}
                      </div>
                      <div class="description">
                        {item?.page_no ? (
                          <p>
                            Page {item.page_no} : {formatDate(item.date)}
                          </p>
                        ) : (
                          <p>Page - : {formatDate(item.date)}</p>
                        )}
                        <h1>{item.campaign_name || " "}</h1>
                        <h5>Edition : {mergeEditions(item.edition) || " "}</h5>
                        <h5>Ad Format : {item.ad_format || " "} </h5>
                        <h5>Brand Name : {item.brand_name || " "} </h5>
                      </div>

                      <div class="moreOptions">
                        {localStorage.getItem("role") === roles.b2b ? (
                          <div
                            class="option"
                            onClick={async () => {
                              handleShow("edit", item);
                              setFlag("edit");
                            }}
                          >
                            <img src={EditIcon} alt="" />
                            <h6>Edit</h6>
                          </div>
                        ) : null}
                        <div
                          class="option"
                          onClick={async () => {
                            setAdvDetails(item.advdetails);
                            setPreview(true);
                          }}
                        >
                          <img src={UserIcon} alt="" />
                          <h6>Advertisers</h6>
                        </div>
                      </div>
                    </li>
                  );
                } else {
                  return (
                    <li
                      ref={index === data.length - 1 ? lastItemRef : null}
                      key={item.id}
                    >
                      <div class="theme">
                        {item?.image_url ? (
                          <img src={item.image_url} alt="ads" />
                        ) : (
                          <img src={NoImage} alt="placeholder" />
                        )}
                        <div class="blur">
                          {" "}
                          {item?.image_url ? (
                            <img src={item.image_url} alt="ads" />
                          ) : (
                            <img src={NoImage} alt="placeholder" />
                          )}
                        </div>
                        <div class="publisher">
                          {item?.newspaper_name ? (
                            <h6 style={getColors(item?.newspaper_name)}>
                              {item.newspaper_name}
                            </h6>
                          ) : null}
                          {item?.ad_type === "Local" ? (
                            <h6 class="local">{item.brand_type}</h6>
                          ) : item?.brand_type === "National" ? (
                            <h6 class="national">{item.brand_type}</h6>
                          ) : (
                            <h6 class="districts">{item.brand_type}</h6>
                          )}
                        </div>
                        <p className="location">
                          <img
                            src={LocationSVG}
                            alt="location_name"
                            title={item.location}
                          />
                          {item.location}
                        </p>
                        <p class="estimation">
                          Est Val: <strong>{item.estimated_value || 0}</strong>
                        </p>
                        {item.image_url ? (
                          <Button
                            className="previewBtn"
                            variant="neutral"
                            onClick={() => {
                              setImgSrc(item.image_url);
                              setOpen(true);
                            }}
                          >
                            Preview
                          </Button>
                        ) : null}
                      </div>
                      <div class="description">
                        {item?.page_no ? (
                          <p>
                            Page {item.page_no} : {formatDate(item.date)}
                          </p>
                        ) : (
                          <p>Page - : {formatDate(item.date)}</p>
                        )}
                        <h1>{item.campaign_name || " "}</h1>
                        <h5>Edition : {mergeEditions(item.edition) || " "}</h5>
                        <h5>Ad Format : {item.ad_format || " "} </h5>
                        <h5>Brand Name : {item.brand_name || " "} </h5>
                      </div>

                      <div class="moreOptions">
                        {localStorage.getItem("role") === roles.b2b ? (
                          <div
                            class="option"
                            onClick={async () => {
                              handleShow("edit", item);
                              setFlag("edit");
                            }}
                          >
                            <img src={EditIcon} alt="" />
                            <h6>Edit</h6>
                          </div>
                        ) : null}
                        <div
                          class="option"
                          onClick={async () => {
                            setAdvDetails(item.advdetails);
                            setPreview(true);
                          }}
                        >
                          <img src={UserIcon} alt="" />
                          <h6>Advertisers</h6>
                        </div>
                      </div>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        ) : !data?.length && !loader ? (
          <NoDataFound colspan="17" />
        ) : (
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        )
      }
      {infLoader ? (
        <div className="w-full d-flex justify-center items-center">
          <TableLoader />{" "}
        </div>
      ) : null}
      {/* <div className={`flex justify-end stickBottom ${scrolltopdata}`}>
                {totalPages > 1 && (
                    <Paginator
                        pageCount={totalPages}
                        handlePageClick={handlePageClick}
                        forcePage={currentPage} />)}
            </div> */}

      <SlDrawer
        label={"Advertiser Details"}
        open={preview}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setPreview(false);
          setAdvDetails();
        }}
        style={{ "--size": "70vw" }}
      >
        <div className="flex justify-end mb-5"></div>
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Category</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            {advDetails?.length && !loader ? (
              <tbody>
                {advDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.adv_name || "-"}</td>
                      <td>{item.adv_designation || "-"}</td>
                      <td>{item.adv_email || "-"}</td>
                      <td>{item.adv_category || "-"}</td>
                      <td>{item.adv_phone || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !advDetails?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
      </SlDrawer>
      <Modal
        className="birdview-image-preview"
        show={open}
        backdrop="static"
        onHide={() => setOpen(false)}
      >
        <Modal.Header closeButton>Image Preview</Modal.Header>
        <Modal.Body>
          <img src={imgSrc} alt="" />
        </Modal.Body>
      </Modal>
      <Modal show={showConsultees} onHide={() => {setShowConsultees(false); form1.reset()}} title="Add Consultee">
  <ModalHeader closeButton>
    Add Consultee
  </ModalHeader>
  <ModalBody>
  <form onSubmit={form1.handleSubmit(addConsultees)}>
      {/* Name */}
      <div className="mb-3">
        <label htmlFor="name" className="form-label">Name</label>
        <input
          type="text"
          id="name"
          {...form1.register('person_name', { required:"Person Name is required!"})}
          className="form-control"
          placeholder="Enter Name"
        />
       {form1.formState.errors && <p className="text-red-600"> {form1.formState.errors?.person_name?.message} </p> }
      </div>

      {/* Phone Number */}
        <div className="w-1/2">
          <label htmlFor="mobile" className="form-label">Phone Number</label>
          <input
            type="text"
            id="mobile"
            {...form1.register('contact', {required:"Phone Number is required!"})}
            className="form-control"
            placeholder="Phone Number"
          />
       {form1.formState.errors && <p className="text-red-600"> {form1.formState.errors?.contact?.message} </p>   }
          
        </div>

      {/* Address */}
      <div className="mb-3">
        <label htmlFor="address" className="form-label">Address</label>
        <textarea
          id="address"
          rows={3}
          {...form1.register('address', {required:'Address is required!'})}
          className="form-control"
          placeholder="Enter Address"
        />
       {form1.formState.errors && <p className="text-red-600"> {form1.formState.errors?.address?.message} </p>   }
       
      </div>

      {/* Submit Button */}
      <button className="ml-auto justify-end flex btn btn-primary" type="submit">
        Submit
      </button>
    </form>
  </ModalBody>
</Modal>

      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex gap-4 flex-wrap w-full">
            <div className="w-full">
              <Select
                placeholder="Select District"
                name="source"
                size="medium"
                value={selectedLocation}
                onChange={(selected) => {
                  setSelectedLocation(selected || []);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[...locations]}
                isMulti
              />
            </div>
            <div className="w-full">
              <Select
                className=""
                placeholder="Select Newspaper"
                name="source"
                size="medium"
                value={selectedNewspaper}
                onChange={(selected) => {
                  setSelectedNewspaper(selected || []);
                  setData([]);
                  setCurrentPage(0);
                }}
                options={[
                  ...newspaperData
                    .filter((item) => item.name !== "Way2news")
                    .map((item) => {
                      return { label: item.name, value: item.name };
                    }),
                ]}
                isMulti
              />
            </div>

            <div className="w-full">
              <SlSelect
                className="w-full"
                placeholder="Select Ad Type"
                name="adType"
                size="medium"
                value={adType}
                onSlChange={(e) => {
                  setAdType(e.target.value);
                  setData([]);
                  setCurrentPage(0);
                }}
              >
                <SlOption key={0} value={"Finite"}>
                  Finite
                </SlOption>
                <SlOption key={1} value={"Infinite"}>
                  Infinite
                </SlOption>
              </SlSelect>
            </div>
            <div className="w-full">
              <SlSelect
                placeholder="Select Brand Type"
                name="adType"
                size="medium"
                value={selectedBrandType}
                onSlChange={(e) => {
                  setSelectedBrandType(e.target.value);
                  setData([]);
                  setCurrentPage(0);
                }}
              >
                <SlOption key={0} value={"0"}>
                  All
                </SlOption>
                <SlOption key={1} value={"1"}>
                  National
                </SlOption>
                <SlOption key={2} value={"2"}>
                  Local
                </SlOption>
              </SlSelect>
            </div>

            <SlInput
              className="w-full"
              size="medium"
              placeholder="Newspaper/Edition/Adv Name "
              onSlInput={debounce(searchFilterOnChange, 500)}
            >
              <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
            </SlInput>
            <div className="border rounded-lg min-w-fit h-fit">
              <Datepicker
                classNames="form-input"
                value={dateRange}
                primaryColor={"cyan"}
                showShortcuts={true}
                useRange={true} // Allow date range selection
                configs={{
                  shortcuts: {
                    today: "today",
                    yesterday: "yesterday",
                    currentMonth: "currentMonth",
                    pastMonth: "lastMonth",
                  },
                }}
                onChange={handleDateRange}
              />
            </div>
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default CompetitorDataAI;
